module.exports = __webpack_public_path__ + "static/media/inplayer-icon-small.4b54a69d.svg";